// extracted by mini-css-extract-plugin
var _1 = "_pnAOq";
var _2 = "_ROJq6";
var _3 = "_xGj56";
var _4 = "_VUUFO";
var _5 = "_Dh4AF";
export { _1 as "buttons", _2 as "duplicateModal", _3 as "modalTitle", _4 as "nameInput", _5 as "nameInputContainer" }
